import { createAsyncThunk } from "@reduxjs/toolkit"
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios"

export interface IReportPayload {
	filter?: unknown | undefined
}

export interface IReportResponse {
	data: string
}

export const createReport = createAsyncThunk<
	IReportResponse,
	IReportPayload,
	{ rejectValue: AxiosError }
>("report/create", async ({ filter }: IReportPayload, { rejectWithValue }) => {
	try {
		const headerConfig: AxiosRequestConfig = {
			withCredentials: true,
		}

		const baseUrl = `${process.env.REACT_APP_FILE_SERVICE_API_URL}/fileservice/apifile/v2/generate-report`
		const parameters = new URLSearchParams()

		if (filter && Object.keys(filter).length > 0) {
			parameters.append("filter", JSON.stringify(filter))
		}

		const axiosUrl = `${baseUrl}${parameters ? "?" + parameters.toString() : ""}`
		const response: AxiosResponse<string> = await axios.post(
			axiosUrl,
			undefined,
			headerConfig
		)

		return response
	} catch (error) {
		const axiosError = error as AxiosError<string>
		return rejectWithValue(axiosError?.response?.data ?? "generic")
	}
})
